import { ProductType } from '@tink/core/src/types';
import { connect } from 'react-redux';
import { ComponentType, useState } from 'react';
import { AppState, ConnectedPropsWithoutDispatch } from '../../stores/redux-store';
import { ProviderEntity } from '../../models/provider';
import { ExtendConsentProduct } from '../../models/product';
import {
  SuccessNotification as SuccessNotificationImport,
  SuccessNotificationProps,
} from '../../core/screens/SuccessNotification/SuccessNotification';
import {
  LoginMachineResponse,
  LoginMachineView as LoginMachineViewImport,
  LoginMachineViewProps,
} from '../../components/screens/molecules/SubmitCredentialsScreen/LoginMachineView';
import { useConfiguration } from '../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { applicationParameters } from '../../utilities/application-parameters';
import { ExtendConsentResult } from './ExtendConsentResult';

export const extendConsentProducts: ExtendConsentProduct[] = [
  ProductType.TRANSACTIONS,
  ProductType.BUSINESS_TRANSACTIONS,
  ProductType.ACCOUNT_CHECK,
  ProductType.PRODUCTS,
  ProductType.CREDENTIALS,
];

export const extendConsentProductsRegex = extendConsentProducts.join('|');

export type ExtendConsentDirectorProps = PropsFromRedux & {
  LoginMachineView?: ComponentType<LoginMachineViewProps>;
  SuccessNotification?: ComponentType<SuccessNotificationProps>;
};

export const ExtendConsentDirectorPresenter = ({
  userId,
  userHintId,
  session,
  provider,
  oauthDescribe,
  credentials,
  LoginMachineView = LoginMachineViewImport,
  SuccessNotification = SuccessNotificationImport,
}: ExtendConsentDirectorProps) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const callbackUri = applicationParameters.get('callbackUri');

  const { data: configurationData } = useConfiguration();

  if (isSuccess) {
    const applicationSuccessResult = new ExtendConsentResult({
      credentialsId: credentials.id,
    });

    return <SuccessNotification applicationSuccessResult={applicationSuccessResult} />;
  }

  const onDone = (r: LoginMachineResponse) => {
    if (r.type === 'EXTENDED_CONSENT') {
      setIsSuccess(true);
    }
  };

  return (
    <LoginMachineView
      operation="extendConsent"
      session={session}
      provider={provider}
      userId={userId}
      userHintId={userHintId}
      oauthDescribe={oauthDescribe}
      credentials={credentials}
      credentialsId={applicationParameters.get('credentialsId')}
      configurationData={configurationData}
      productNames={[]}
      userCredentials={[]}
      refreshableItems={[]}
      renderProviderFields
      onDone={onDone}
      callbackUri={callbackUri}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    userId: state.user.user?.id ?? '',
    userHintId: state.user.idHint,
    isClientVerified: state.oauth.description?.verified ?? false,
    session: state.session.data,
    credentials: state.userCredentials.data[0],
    provider: (state.providers.data as ProviderEntity[])[0],
    oauthDescribe: state.oauth.description,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const ExtendConsentDirector = connector(ExtendConsentDirectorPresenter);
